<template>

  <v-dialog
    v-model="show"
    max-width="400px"
    persistent
  >
    <m-pay-generic-editor
      :title="title"
      :bean="model"
      :beanProperties="beanProperties"
      :readOnlyProperties="readOnlyProperties"
      :beanPropertyValues="beanPropertyValues"
      :validationRules="validationRules"
      submitButtonColor="error"
      @submit="submit($event)"
      @cancel="cancel"
    >
      <template slot="submitButton">
        Reverse
        <v-icon right dark>compare_arrows</v-icon>
      </template>
    </m-pay-generic-editor>
  </v-dialog>

</template>

<script>
import MPayGenericEditor from './MPayGenericEditor';
import formatters from '../utils/formatters';

export default {
  name: 'MPayTransactionReversal',

  props: {
    show: Boolean,
    transaction: Object,
  },

  components: {
    MPayGenericEditor,
  },

  data: () => ({
    model: {
      transactionId: '',
      amount: 0,
      currency: '',
      reasonCode: '',
      reasonNote: '',
    },
    beanProperties: [
      'amount',
      'currency',
      'reasonCode',
      'reasonNote',
    ],
    readOnlyProperties: [
      'amount',
    ],
    formatters,
  }),

  computed: {
    validationRules() {
      return [
        `required|between:0.01,${this.transaction.amount}`,
        `required|is:${this.transaction.currency}`,
        'required',
        '',
      ];
    },
    beanPropertyValues() {
      // TODO: fetch reference data from server
      return {
        reasonCode: ['WRONG_AMOUNT', 'DUPLICATE', 'OTHER_REVERSAL'],
      };
    },
    title() {
      return `Reverse transaction for ${formatters.amount(this.transaction.amount)} ${this.transaction.currency}`;
    },
  },

  methods: {
    submit(model) {
      this.$emit('update:show', false);
      this.$emit('reverse', model);
    },
    cancel() {
      this.$emit('update:show', false);
    },
    resetModel() {
      this.model = {
        transactionId: this.transaction.id,
        amount: this.transaction.amount,
        currency: this.transaction.currency,
        reasonCode: '',
        reasonNote: '',
      };
    },
  },

  watch: {
    transaction() {
      this.resetModel();
    },
    show() {
      this.resetModel();
    },
  },

};
</script>



// WEBPACK FOOTER //
// src/components/MPayTransactionReversal.vue